function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 24"
}, props), React.createElement("g", {
  fill: "none"
}, React.createElement("path", {
  fill: "#87BBFD",
  d: "M12.5 22.48l-2.01 1.29a1.5 1.5 0 01-2.07-.46l-.06-.12-1.1-2.11-2.38.1a1.5 1.5 0 01-1.56-1.42v-.14l.1-2.38-2.11-1.1a1.5 1.5 0 01-.64-2.02l.06-.11L2.02 12 .73 9.99a1.5 1.5 0 01.46-2.07l.12-.06 2.11-1.1-.1-2.38a1.5 1.5 0 011.42-1.56h.14l2.38.1L8.36.81a1.5 1.5 0 012.02-.64l.11.06 2.01 1.29L14.51.23a1.5 1.5 0 012.07.46l.06.12 1.1 2.11 2.38-.1a1.5 1.5 0 011.56 1.42v.14l-.1 2.38 2.11 1.1a1.5 1.5 0 01.64 2.02l-.06.11L22.98 12l1.29 2.01c.44.7.23 1.62-.46 2.07l-.12.06-2.11 1.1.1 2.38a1.5 1.5 0 01-1.42 1.56h-.14l-2.38-.1-1.1 2.11a1.5 1.5 0 01-2.02.64l-.11-.06-2.01-1.29z"
}), React.createElement("path", {
  fill: "#555ABF",
  d: "M16.69 7.19a1.5 1.5 0 012.25 1.98l-.13.14-6.75 6.75a1.5 1.5 0 01-1.98.13l-.14-.13-3.75-3.75a1.5 1.5 0 011.98-2.25l.14.13L11 12.88l5.69-5.7z"
}))));